module.exports = __webpack_public_path__ + "img/wagon_stopped.6bfdd720.svg";